export default __webpack_public_path__ + "static/Contact-1ea4b574b7730e978b541e19a637d9a3.mp4";